let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let CopyEvent = require("./CopyEvent");
let DeleteEvent = require("./DeleteEvent");
let ChangeSpeaker = require("./ChangeSpeaker");
let LinkOpportunity = require("./LinkOpportunity");
let isEventAccountingLockedForMe = require("../../../../../../utils/isEventAccountingLockedForMe");
let AuthedUserSession = require("../../../../../../utils/AuthedUserSession");

module.exports = dd.createClass({
  __emailToCoWorkers: esUtils.wrapPreventDefault(function () {
    radio("send_event_to_coworkers").broadcast(this.props.event);
  }),
  render() {
    let {event, Displaylists} = this.props;

    return dd.div({className: "well"},
      dd.h3({style: {margin: "0 0 20px 0"}}, "Event Actions"),
      dd.p(null,
        dd.button({className: "btn btn-default", onClick: this.__emailToCoWorkers}, "Email to Co-workers")
      ),
      CopyEvent({event, Displaylists}),
      (isEventAccountingLockedForMe(event) || !AuthedUserSession.doIHaveAccess.full.any(event.sids)) ? null : ChangeSpeaker({event, Displaylists}),
      (isEventAccountingLockedForMe(event) || !AuthedUserSession.doIHaveAccess.full.any(event.sids)) ? null : DeleteEvent({event}),
      AuthedUserSession.is_privatelabel ? null : LinkOpportunity({Displaylists, event})
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/event_actions/index.js